import { render, staticRenderFns } from "./TwismWalletSendCoinsHistory.vue?vue&type=template&id=704a4770&scoped=true&"
import script from "./TwismWalletSendCoinsHistory.vue?vue&type=script&lang=ts&"
export * from "./TwismWalletSendCoinsHistory.vue?vue&type=script&lang=ts&"
import style0 from "./TwismWalletSendCoinsHistory.vue?vue&type=style&index=0&id=704a4770&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a4770",
  null
  
)

export default component.exports